jQuery(document).ready(function () {
   if( jQuery('.blog-products-slide').length > 0 ){
      jQuery('.blog-products-slide').slick({
            dots: true,
            arrows : true,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            adaptiveHeight: true,
            autoplay: false,
            slidesToScroll: 3,
            responsive: [{
                breakpoint: 662,
                settings: {
                  slidesToShow: 1,
                  centerMode: false,
                  slidesToScroll: 1
                }
              }
            ]
          });
    } else {
      jQuery('.show-product-list').wrapAll('<div class="blog-products-slide">');
      jQuery('.blog-products-slide').slick({
            dots: true,
            infinite: true,
            arrows : true,
            speed: 300,
            slidesToShow: 3,
            adaptiveHeight: true,
            autoplay: false,
            slidesToScroll: 3,
            responsive: [{
                breakpoint: 662,
                settings: {
                  slidesToShow: 1,
                  centerMode: false,
                  slidesToScroll: 1
                }
              }
            ]
          });
     }
     if ( jQuery('.blog-share').length > 0 && jQuery(window).width() > 992 ) {
          jQuery('.blog-share,.article-template__content').theiaStickySidebar({
            // Settings
            additionalMarginTop: 100
          });
      }
     if ( jQuery(window).width() < 960) {
             var heafer_h = jQuery("header").outerHeight(!0);
            //var heafer_h = 0;
            //if (jQuery("h2").hasClass("toc-point")) {
              jQuery(".before-single-blog-content").html(
                '<div id="toc_content"><h4>In this article</h4><ol class="toc"></ul></div>'
              );
          // }
            jQuery(".article-template__content h2").each(function (index) {
              var headingid = "heading_h2_" + index;
              jQuery(this).attr("id", headingid);
              var item = jQuery(this);
              jQuery("#toc_content .toc").append(
                '<li><a href="#' + headingid + '">' + item.text() + "</a></li>"
              );
            });
            jQuery("#toc_content a").on("click", function () {
              jQuery("html, body").animate(
                { scrollTop: jQuery(this.hash).offset().top - heafer_h },
                1000
              );
              return !1;
            })
     } else {
             var heafer_h = jQuery("header").outerHeight(!0);
            //var heafer_h = 0;
            //if (jQuery("h2").hasClass("toc-point")) {
              jQuery(".left-single-blog-content").html(
                '<div id="toc_content"><h4>In this article</h4><ol class="toc"></ul></div>'
              );
            //}
            jQuery(".article-template__content h2").each(function (index) {
              var headingid = "heading_h2_" + index;
              jQuery(this).attr("id", headingid);
              var item = jQuery(this);
              jQuery("#toc_content .toc").append(
                '<li><a href="#' + headingid + '">' + item.text() + "</a></li>"
              );
            });
            jQuery("#toc_content a").on("click", function () {
              jQuery("html, body").animate(
                { scrollTop: jQuery(this.hash).offset().top - heafer_h },
                1000
              );
              return !1;
            });    
     }
      var heafer_h = jQuery("header").outerHeight(!0);
     jQuery(".blog-rightsidebar h4").on("click", function () {
        if( jQuery(this).parent('.menu-link').hasClass("open") ){
          jQuery(this).parent('.menu-link').removeClass("open");
        }else{
          jQuery(".blog-rightsidebar .blog-right-menu > .menu-link").removeClass("open");
          jQuery(this).parent('.menu-link').addClass("open");
        }
       jQuery("html, body").animate(
                { scrollTop: jQuery('#right-sidebar').offset().top - heafer_h },
                1000
              );
      });
    jQuery(".blog-rightsidebar .blog-right-menu > .menu-link").first().addClass("open");
});